import {create} from "zustand";
import { persist } from "zustand/middleware";


export const useAssessment = create(
  persist(
    (set, get) => ({
      assessmentDocs: null,
      assessmentDoc: null,
      questionDocs:null,
      assessmentAction:{
        assessmentId:"",
        action:""
      },
      timer:null,
      _hasHydrated: false,
      assessmentResultDocs:null,
      setAssessmentResult: (assessmentResultDocs) => {
        return set({ assessmentResultDocs });
      },
      setAssessmentAction: (assessmentAction) => {
        return set({ assessmentAction });
      },
      setAssessment: (assessmentDoc) => {
        return set({ assessmentDoc });
      },
      setAssessments: (assessmentDocs) => {
        return set({ assessmentDocs });
      },
      setQuestionDocs: (questionDocs) => {
        return set({ questionDocs });
      },
      setTimer: (timer) => {
        return set({ timer });
      },
      getassessments: () => {
        return get().assessmentDocs;
      },
      setHasHydrated: (value) => set({ _hasHydrated: value }),
    }),
    {
      name: "assessment-storage",
      getStorage: () => localStorage,
      partialize: (state) => ({
        _hasHydrated: state._hasHydrated,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
